import * as React from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Box, Button, ButtonProps, Grid, Tab, Tabs, Typography } from '@mui/material';
import $ from "jquery";
import { DataGrid, GridCsvExportOptions, GridCsvGetRowsToExportParams, GridToolbarContainer, gridExpandedSortedRowIdsSelector, useGridApiContext } from '@mui/x-data-grid';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import Common from '../../utilities/common';
import Layout from '../../components/Utilities/Layout';
import EntitySettings from '../../components/EntitySettings';
import SecurityTrimmer from '../../components/Utilities/SecurityTrimmer';
import { Entity, PermissionLevel } from '../../utilities/Permisos';
import GppGoodOutlinedIcon from '@mui/icons-material/GppGoodOutlined';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import EntityPermissions from '../../components/EntityPermissions';

const getFilteredRows = ({ apiRef }: GridCsvGetRowsToExportParams) =>
    gridExpandedSortedRowIdsSelector(apiRef);

const CustomToolbar = () => {
    const apiRef = useGridApiContext();
  
    const handleExport = (options: GridCsvExportOptions) =>
      apiRef.current.exportDataAsCsv(options);
  
    const buttonBaseProps: ButtonProps = {
      color: 'primary',
      size: 'small',
      startIcon: <FileDownloadOutlinedIcon />,
    };
  
    return (
      <GridToolbarContainer>
        <Button
          {...buttonBaseProps}
          onClick={() => handleExport({ getRowsToExport: getFilteredRows, fileName: 'niveles_permisos' })}
        >
          Exportar CSV
        </Button>
      </GridToolbarContainer>
    );
}

export interface IUserState {
    data: any[];
    dataWithoutGrouping: any[];
    selectedTab: string;
}

export default class Permisos extends React.Component<{}, IUserState> {
    public constructor(props: {}) {
        super(props);

        this.state = {
            data: [],
            dataWithoutGrouping: [],
            selectedTab: 'entidad'
        };
    }

    componentDidMount(): void {
        this.Get();
    }

    public render(): React.ReactElement<{}> {
        return (
            <Layout breadcrumb={
                [
                    {
                        title: 'Inicio',
                        url: '/'
                    },
                    {
                        title: 'Configuración',
                        url: '/settings'
                    },
                    {
                        title: 'Permisos',
                        url: ''
                    }
                ]
            }>
                <Box className='stepper'>
                    <Grid container>
                        <Grid item xs={1}>
                            <Typography>
                                <GppGoodOutlinedIcon className='mainIcon'/>
                            </Typography>
                        </Grid>
                        <Grid item xs={9}>
                            <Typography className='mainTitle'>
                            Permisos
                            </Typography>
                        </Grid>
                        <SecurityTrimmer entity={Entity.Permisos} permission={PermissionLevel.Ver}>
                            <Grid item xs={2} className='entitySettings'>
                                <EntitySettings entity={Entity.Permisos}/>
                            </Grid>
                        </SecurityTrimmer>
                    </Grid>
                </Box>
                <Box className='main'>
                    <Tabs style={{marginBottom: '40px'}} value={this.state.selectedTab} onChange={(event: React.SyntheticEvent, newValue: string) => {
                            this.setState({
                                selectedTab: newValue
                            });

                            this.GroupData(newValue);
                    }}>
                        <Tab label="Por entidad" value='entidad'/>
                        <Tab label="Por usuario" value='usuario'/>
                        <Tab label="Por permiso" value='permiso'/>
                    </Tabs>
                    {
                        this.state.data.map((permiso: any, index: number) => {
                            return (
                                <Accordion elevation={0}>
                                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                    {
                                        `${permiso.title} (${permiso.data.length})`
                                    }
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <DataGrid
                                            style={{backgroundColor: '#f4f4f4', boxShadow: '0px 12px 20px -12px rgba(0, 0, 0, .5)'}}
                                            slotProps={{ pagination: { labelRowsPerPage: 'Filas por página' } }}
                                            autoHeight
                                            rows={permiso.data}
                                            columns={[
                                                { field: 'title', headerName: this.GetTitleHeaderName(), headerClassName: 'bgLightGray', width: 300 },
                                                { field: 'description', headerName: this.GetDescriptionHeaderName(), headerClassName: 'bgLightGray', flex: 1 }
                                            ]}
                                            hideFooterPagination={true}
                                            hideFooter={true}
                                        />
                                        {
                                            this.state.selectedTab == 'entidad' && (
                                                <div className='textRight' style={{marginTop: '20px'}}>
                                                    <EntityPermissions entity={Common.GetEntity(permiso.title)} showAsButton={true} onClose={() => {
                                                        this.Get();
                                                    }}/>
                                                </div>
                                            )
                                        }
                                    </AccordionDetails>
                                </Accordion>
                            )
                        })
                    }
                </Box>
            </Layout>
        )
    }

    private GetTitleHeaderName(): string {
        const selectedTab = this.state.selectedTab;

        switch(selectedTab) {
            case 'usuario':
            case 'permiso':
                return 'Entidad';
            default:
                return 'Usuario'
        }
    }

    private GetDescriptionHeaderName(): string {
        const selectedTab = this.state.selectedTab;

        switch(selectedTab) {
            case 'permiso':
                return 'Usuario';
            default:
                return 'Permiso'
        }
    }

    private Get(): void {
        let url = `${Common.END_POINT}/permissions`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            const data: any[] = [];

            for(let i = 0; i < response.length; i++) {
                let dataObject: any = data.find((value: any) => {
                    return value.title == response[i].entidad;
                })

                if(dataObject == null) {
                    dataObject = {};
                    dataObject.title = response[i].entidad;
                    dataObject.data = [];
                    data.push(dataObject);
                }

                dataObject.data.push(
                    {
                        id: response[i].id,
                        title: response[i].userName,
                        description: response[i].permiso
                    }
                )
            }

            console.log(data);

            this.setState(
                {
                    data: data,
                    dataWithoutGrouping: response
                }
            );
        }).fail((jqXHR: any, textStatus: any, errorThrown: any) => {
            console.log(jqXHR);
        });
    }

    private GroupData(selectedTab: string): void {
        const data: any[] = [];
        const dataWithoutGrouping = this.state.dataWithoutGrouping;

        for(let i = 0; i < dataWithoutGrouping.length; i++) {
            let dataObject: any = data.find((value: any) => {
                if(selectedTab == 'entidad') {
                    return value.title == dataWithoutGrouping[i].entidad;
                }
                
                if(selectedTab == 'usuario') {
                    return value.title == dataWithoutGrouping[i].userName;
                }

                if(selectedTab == 'permiso') {
                    return value.title == dataWithoutGrouping[i].permiso;
                }
            })

            if(dataObject == null) {
                dataObject = {};
                if(selectedTab == 'entidad') {
                    dataObject.title = dataWithoutGrouping[i].entidad;
                }
                if(selectedTab == 'usuario') {
                    dataObject.title = dataWithoutGrouping[i].userName;
                }
                if(selectedTab == 'permiso') {
                    dataObject.title = dataWithoutGrouping[i].permiso;
                }
                
                dataObject.data = [];
                data.push(dataObject);
            }

            if(selectedTab == 'entidad') {
                dataObject.data.push(
                    {
                        id: dataWithoutGrouping[i].id,
                        title: dataWithoutGrouping[i].userName,
                        description: dataWithoutGrouping[i].permiso
                    }
                )
            }

            if(selectedTab == 'usuario') {
                dataObject.data.push(
                    {
                        id: dataWithoutGrouping[i].id,
                        title: dataWithoutGrouping[i].entidad,
                        description: dataWithoutGrouping[i].permiso
                    }
                )
            }

            if(selectedTab == 'permiso') {
                dataObject.data.push(
                    {
                        id: dataWithoutGrouping[i].id,
                        title: dataWithoutGrouping[i].entidad,
                        description: dataWithoutGrouping[i].userName
                    }
                )
            }
        }

        this.setState(
            {
                data: data
            }
        )
    }
}